module.exports = __webpack_public_path__ + "assets/img/dzh-2.b7929c11.jpg";